import React, { useEffect, useState } from "react";
import { Form, Offcanvas, Spinner } from "react-bootstrap";
import { editorS3FileManagerServices } from "../../../APIServices/Editor/editorS3FileManagerServices";
import { useParams } from "react-router";

const AddNewFolder = ({ Show, Hide, Title, folderData, setFileFolderUpdater }) => {
  const [buttonLoader, setButtonLoader] = useState(false);
  const [name, setName] = useState("");
  const { studyId } = useParams()

  const createS3EditorFolder = async () => {
    setButtonLoader(true)
    let userData = { studyId };
    userData.folder = `${folderData?.fullPath || ""}${name}`
    let data = await editorS3FileManagerServices.createS3EditorFolder(
      userData
    );
    setButtonLoader(false)
    if (data?.statusCode === 200) {
      setFileFolderUpdater(Math.floor(1000000000 + Math.random() * 9000000000));
      setName("")
      Hide()
    }
  };

  return (
    <>
      <Offcanvas show={Show} onHide={Hide} placement="end">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>{Title}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Form.Group className="mb-1">
            <Form.Label className="mb-1 fw-bold">
              Folder Name{" "}
              <abbr title="Required" className="text-danger">
                *
              </abbr>
            </Form.Label>
            <Form.Control
              type="text"
              rows={3}
              onChange={(e) => setName(e.target.value)}
              value={name}
              className={`fontSize12 ${name === "Uncategories" ? "border-danger" : ""}`}
              placeholder="Enter Folder Name"
            />
          </Form.Group>
          {name === "Uncategories" && (
            <span style={{ fontSize: 10, color: "red", fontWeight: 600 }}>
              Uncategories name is Default Folder Name, Please Change Name
            </span>
          )}
        </Offcanvas.Body>
        <div className="text-end p-2 border-top">
          <button
            onClick={createS3EditorFolder}
            disabled={buttonLoader || !name || name === "Uncategories"}
            title={Title}
            className="updateProfile"
          >
            {buttonLoader ? (
              <div className="hstack gap-2">
                <Spinner size="sm" /> Adding...
              </div>
            ) : (
              "Add Now"
            )}
          </button>
        </div>
      </Offcanvas>
    </>
  );
};

export default AddNewFolder;
